export default function Check(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className="icon-ratio"
      {...props}
    >
      <circle cx="10" cy="10" r="7.5" fill="#F5F5F5" stroke="#049595" strokeWidth="4" />
    </svg>
  );
}
